module.exports = __webpack_public_path__ + "img/nowbuttonPressed.2e4809d4.png";